const breakpoints = {
  values: {
    xs: 0,
    sm: 400,
    md: 800,
    lg: 1100,
    xl: 1920,
  },
};

export default breakpoints;
